import  WidgetInjectionTypeEnum         from './WidgetInjectionTypeEnum';
import { ConfigService }                from '../../..';


/**
 * Define the session entity.
 */
export class SessionEntity {
    public isInitialState!: boolean;
    public isWaitingForAnswer!: boolean;
    public isIntroductoryMsgShown!: boolean;
    public isPresentationAvatarAllowed!: boolean;
    public lastMsgSentTimestamp: number | undefined;
    public score!: number;

    /**
     * Constructor
     * 
     * @param conversationId - The token provided by Bot server to identify the user's session
     * @param guestId - The guest identifier generated for the user to identify conversation server logs
     * @param botName - The bot name configured by the administrator
     * @param originURL - The origin url of the request
     * @param integrationMode - The configured integration mode
     * @param nextMsgWatermark - The identifier to be used for the message
     * @param isRefresh - If we refreshed the last session
     */
    constructor(public conversationId: string,
                public guestId: string,
                public botName: string,
                public originURL: string,
                public integrationMode: WidgetInjectionTypeEnum,
                public nextMsgWatermark: number,
                public isRefresh: boolean = false) {

                    this.score = -1;
                    this.isInitialState = true;
                    this.isWaitingForAnswer = false;
                    this.isIntroductoryMsgShown = false;
                    if(!isRefresh){
                        this.isPresentationAvatarAllowed = !ConfigService.isEmbeddedModeConfigured();
                    }
                    else{
                        this.isPresentationAvatarAllowed = false;
                    } 
                }
}
